import { getFormattedDisplayNameForEqlField } from '@modules/common/components/EqlFieldsAutoComplete/helpers';
import { QuantifyQuery } from '@modules/quantify/store/types';
import { CsvColumnType, ExportCsvColumn } from 'generated/graphql';

interface getFieldLabelColumnParams {
  groupBy: QuantifyQuery['groupByField'];
  shouldRemoveFileUploadPrefix: boolean;
  isUnifiedFieldEnabled: boolean;
}

export function getFieldLabelColumn({
  groupBy,
  shouldRemoveFileUploadPrefix,
  isUnifiedFieldEnabled,
}: getFieldLabelColumnParams) {
  const fieldColumn: ExportCsvColumn = {
    title: groupBy
      ? getFormattedDisplayNameForEqlField({
          eqlField: groupBy,
          shouldRemoveFileUploadPrefix,
          isUnifiedFieldEnabled,
        })
      : '',
    type: CsvColumnType.String,
    isFieldColumn: true,
  };

  return fieldColumn;
}
